//todo remove
const Pages = {
	Rover: "/",
	Field : "Field",
	FieldResult : "Field-Result",
	Obstacles : "Obstacles",
	ObstaclesResult : "Obstacles-Result",
	Points : "Points",
	PointsResult : "Points-Result",
	Page404 : "errors/404",
	Page500 : "errors/500"
  }

  export default Pages;